<div class="info-list py-3" [ngClass]="{ freemium: isFreemium }">
  <app-app-info-list-item [label]="'Ad Fraud (IVT)'"
                          [type]="'risk'"
                          [value]="data?.riskOverview?.givtSivtRateRating"
                          [showFreemiumLock]="isFreemium"
                          (goToSectionClick)="goToSection($event)">
  </app-app-info-list-item>
  <div class="divider"></div>
  <app-app-info-list-item [label]="'Click Fraud Risk'"
                          [type]="'risk'"
                          [value]="data?.riskOverview?.clickFraudRiskScore"
                          [showFreemiumLock]="isFreemium"
                          (goToSectionClick)="goToSection($event)">
  </app-app-info-list-item>
  <div class="divider"></div>
  <app-app-info-list-item [label]="'Viewability Risk'"
                          [type]="'risk'"
                          [value]="data?.riskOverview?.nonGivtSivtViewabilityRating"
                          [showFreemiumLock]="isFreemium"
                          (goToSectionClick)="goToSection($event)">
  </app-app-info-list-item>
  <div class="divider"></div>
  <app-app-info-list-item [label]="'Domain Masking'"
                          [type]="'risk'"
                          [value]="data?.riskOverview?.maskingRatioRating"
                          [showFreemiumLock]="isFreemium"
                          (goToSectionClick)="goToSection($event)">
  </app-app-info-list-item>
  <div class="divider"></div>
  <app-app-info-list-item [label]="'Major Traffic Source'"
                          [value]="data?.riskOverview?.majorTrafficSource"
                          [showFreemiumLock]="isFreemium"
                          (goToSectionClick)="goToSection($event)">
  </app-app-info-list-item>
</div>
